import ServiceContent from "@/model/Content/ServiceContent"

interface ISkiSchoolServiceContent {

}

class SkiSchoolServiceContent extends ServiceContent implements ISkiSchoolServiceContent {

    constructor() {
        super()
    }
    
}

export default SkiSchoolServiceContent